export var createMidiOutputs = function createMidiOutputs(wrapSubscribeFunction) {
  return function (midiAccess) {
    return wrapSubscribeFunction(function (observer) {
      var midiOutputs = Array.from(midiAccess.outputs.values());

      var emitMidiOutputs = function emitMidiOutputs() {
        var midiAccessOutputs = midiAccess.outputs;

        if (midiOutputs.length !== midiAccessOutputs.size || midiOutputs.some(function (_ref) {
          var id = _ref.id;
          return !midiAccessOutputs.has(id);
        })) {
          midiOutputs = Array.from(midiAccessOutputs.values());
          observer.next(midiOutputs);
        }
      };

      observer.next(midiOutputs);
      midiAccess.addEventListener('statechange', emitMidiOutputs);
      return function () {
        return midiAccess.removeEventListener('statechange', emitMidiOutputs);
      };
    });
  };
};